/* 该文件已全局引入，无需每个界面在引入 */
import {
    axiosfetch
} from './config';
import api from "./apiURL"

let BUSINESS_API_BASE  = 'https://ef-biz-notice.eastfair.cn'

/** 登录-根据展会编码获取展会路由 */
const getOrganizerLinkList = (data) => {
    return axiosfetch({
        url: api.organizerLinkList,
        method: 'post',
        params: data
    })
}

/** 开关/配置项/数据项列表 */
const getConfigurationInformation = (data) => {
    return axiosfetch({
        url: api.getConfigurationInformation,
        method: 'post',
        params: data
    })
}

/** 获取展会列表  */
const getExhibitionList = (data, unNeedAuth) => {
    return axiosfetch({
        url: api.exhibitionList,
        method: 'post',
        params: data,
        unNeedAuth //true // 不需要token
    })
}

/** 获取国家 */
const getCountryList = (data) => {
    console.log(data);
    return axiosfetch({
        url: api.countryList,
        method: 'get',
        params: data
    })
}

/** 获取省份 */
const getProvinceList = (data) => {
    return axiosfetch({
        url: api.provinceList,
        method: 'get',
        params: data
    })
}

/** 获取城市 */
const getCityList = (data) => {
    return axiosfetch({
        url: api.cityList,
        method: 'get',
        params: data
    })
}

/** 提交报名信息 */
const exhibitorInsert = (data) => {
    return axiosfetch({
        url: api.exhibitorInsert,
        method: 'post',
        params: data
    })
}

/** 提交报名信息-观众 */
const visitorInsert = (data, unNeedAuth) => {
    return axiosfetch({
        url: api.visitorInsert,
        method: 'post',
        params: data,
        unNeedAuth
    })
}

/** ccbn获取微信签名 */
const getWxConfig = (data) => {
    return axiosfetch({
        url: api.wxConfig,
        method: 'post',
        params: data
    })
}

/** 查询预约报名展会信息 */
const exhibitorReserveExhibition = (data) => {
    return axiosfetch({
        url: api.exhibitorReserveExhibition,
        method: 'post',
        params: data
    })
}

/** 查询预约报名展会信息-观众 */
const exhibitorReserveVisitor = (data) => {
    return axiosfetch({
        url: api.exhibitorReserveVisitor,
        method: 'post',
        params: data
    })
}

/** 获得直播详情 */
const liveDetail = (data) => {
    return axiosfetch({
        url: api.liveDetail,
        method: 'post',
        params: data
    })
}
/** 获得新闻详情 */
const newsDetails = (data) => {
    return axiosfetch({
        url: "/article/getArticle",
        method: 'post',
        params: data
    })
}
/** TODO  临时处理 金融展 海报分享 详情 */
const jrH5Details = (data) => {
    return axiosfetch({
        url: "/article/getArticlePc",
        method: 'post',
        params: data
    })
}

/** 根据token获取身份 */
const subjectTypeByToken = (data) => {
    return axiosfetch({
        url: api.getSubjectTypeByToken,
        method: 'post',
        params: data
    })
}

/** 获取演讲嘉宾列表 */
const getGuestList = (data) => {
    return axiosfetch({
        url: api.getGuest,
        method: 'post',
        params: data
    })
}

/** 获取一个展商的商品列表 */
const getProductList = (data) => {
    return axiosfetch({
        url: api.queryProductList,
        method: 'post',
        params: data
    })
}

/** 获取海报模版列表 */
const getTemplateList = (data) => {
    return axiosfetch({
        url: api.getTemplateList,
        method: 'post',
        params: data
    })
}

/** 创建海报 */
const addPoster = (data) => {
    return axiosfetch({
        url: api.addPoster,
        method: 'post',
        params: data
    })
}

/** 获取我的海报列表 */
const getPosterPage = (data) => {
    return axiosfetch({
        url: api.getPosterPage,
        method: 'post',
        params: data
    })
}

/** 海报删除 */
const delPoster = (data) => {
    return axiosfetch({
        url: api.delPoster,
        method: 'post',
        params: data
    })
}

/** 获取海报详情 */
const getPosterDetail = (data) => {
    return axiosfetch({
        url: api.getPosterDetail,
        method: 'post',
        params: data
    })
}

/** 修改海报名称 */
const updatePoster = (data) => {
    return axiosfetch({
        url: api.updatePoster,
        method: 'post',
        params: data
    })
}

/** 获取展商基本信息 */
const getExhibitorBaseInfo = (data) => {
    return axiosfetch({
        url: api.getExhibitorBaseInfo,
        method: 'post',
        params: data
    })
}

/** 图片上传 */
const uploadImageByBaseStr = (data) => {
    return axiosfetch({
        baseUrl: BUSINESS_API_BASE,
        url: api.uploadImageByBaseStr,
        method: 'post',
        params: data
    })
}

/** 获取小程序二维码 */
const getACodeUnLimit = (data) => {
    return axiosfetch({
        url: api.getACodeUnLimit,
        method: 'post',
        params: data
    })
}

/** 二维码参数保存接口 */
const saveParam = (data) => {
    return axiosfetch({
        url: api.saveParam,
        method: 'post',
        params: data
    })
}
/** 查询会议*/
const meetingGet = (data) => {
    return axiosfetch({
        url: api.meetingGet,
        method: 'post',
        params: data
    })
}
const meetingList = (data) => {
    return axiosfetch({
        url: api.meetingList,
        method: 'post',
        params: data
    })
}
/** 直播测试地址 */
const live = (data) => {
    return axiosfetch({
        url: api.live,
        method: 'post',
        params: data
    })
}

const getCard = (data) => {
    return axiosfetch({
        url: api.getCard,
        method: 'post',
        params: data,
        unNeedAuth: true
    })
}

const getFigures = data => {
    return axiosfetch({
        url: api.getFigures,
        method: 'post',
        params: data
    })
}

const getNewsDetail = data => {
    return axiosfetch({
        url: api.getNewsDetail,
        method: 'post',
        params: data
    })
}

const readBannerNews = data => {
    return axiosfetch({
        url: api.readBannerNews,
        method: 'post',
        params: data
    })
}

const getExhibition = data => {
    return axiosfetch({
        url: api.getExhibition,
        method: 'post',
        params: data
    })
}

const getExhibitorDetails = data => {
    return axiosfetch({
        url: api.getExhibitorDetails,
        method: 'post',
        params: data
    })
}

const invite = data => {
    return axiosfetch({
        url: api.invite,
        method: 'post',
        params: data
    })
}

const getCozeJwtToken = data => {
    return axiosfetch({
        url: api.getCozeJwtToken,
        method: 'get',
        params: data
    })
}

const getExhibitorEmployeeList = data => {
    return axiosfetch({
        url: api.getExhibitorEmployeeList,
        method: 'post',
        params: data
    })
}

const newAddInviteRecrd = data => {
    return axiosfetch({
        url: api.newAddInviteRecrd,
        method: 'post',
        params: data
    })
}

const inviteRecordList = data => {
    return axiosfetch({
        url: api.inviteRecordList,
        method: 'post',
        params: data
    })
}

const contactPersonList = data => {
    return axiosfetch({
        url: api.contactPersonList,
        method: 'post',
        params: data
    })
}

const newConfirmInviteRecord = data => {
    return axiosfetch({
        url: api.newConfirmInviteRecord,
        method: 'post',
        params: data
    })
}

const getNum = data => {
    return axiosfetch({
        url: api.getNum,
        method: 'post',
        params: data
    })
}

const deleteContactPerson = data => {
    return axiosfetch({
        url: api.deleteContactPerson,
        method: 'post',
        params: data
    })
}

const getEmployeeList = data => {
    return axiosfetch({
        url: api.getEmployeeList,
        method: 'post',
        params: data
    })
}

const distributionEmployee = data => {
    return axiosfetch({
        url: api.distributionEmployee,
        method: 'post',
        params: data
    })
}

const inviteRecordListVisitor = data => {
    return axiosfetch({
        url: api.inviteRecordListVisitor,
        method: 'post',
        params: data
    })
}

const newContactPersonList = data => {
    return axiosfetch({
        url: api.newContactPersonList,
        method: 'post',
        params: data
    })
}

const simpleProductList = data => {
    return axiosfetch({
        url: api.simpleProductList,
        method: 'post',
        params: data
    })
}

const getExhibitorBrowseList = data => {
    return axiosfetch({
        url: api.exhibitorBrowseList,
        method: 'post',
        params: data,
        merge: true
    })
}

const addCollection = data => {
    return axiosfetch({
        url: api.addCollection,
        method: 'post',
        params: data,
        merge: true
    })
}

const getAppointmentPlace = data => {
    return axiosfetch({
        url: api.getAppointmentPlace,
        method: 'post',
        params: data,
        merge: true
    })
}

const getAppointmentList = data => {
    return axiosfetch({
        url: api.appointmentList,
        method: 'post',
        params: data,
        merge: true
    })
}

const browseListWithAI = data => {
    return axiosfetch({
        url: api.browseListWithAI,
        method: 'post',
        params: data,
        merge: true
    })
}

const getCollectionRankList = data => {
    return axiosfetch({
        url: api.getCollectionRankList,
        method: 'post',
        params: data,
    })
}


export default {
    getOrganizerLinkList,
    getConfigurationInformation,
    getExhibitionList,
    getCountryList,
    getProvinceList,
    getCityList,
    exhibitorInsert,
    visitorInsert,
    getWxConfig,
    liveDetail,
    exhibitorReserveExhibition,
    exhibitorReserveVisitor,
    newsDetails,
    jrH5Details,
    subjectTypeByToken,
    getGuestList,
    getProductList,
    getTemplateList,
    addPoster,
    getPosterPage,
    delPoster,
    getPosterDetail,
    updatePoster,
    getExhibitorBaseInfo,
    uploadImageByBaseStr,
    getACodeUnLimit,
    saveParam,
    live,
    meetingGet,
    meetingList,
    getCard,
    getFigures,
    getNewsDetail,
    readBannerNews,
    getExhibition,
    getExhibitorDetails,
    invite,
    getCozeJwtToken,
    getExhibitorEmployeeList,
    newAddInviteRecrd,
    inviteRecordList,
    contactPersonList,
    newConfirmInviteRecord,
    getNum,
    deleteContactPerson,
    getEmployeeList,
    distributionEmployee,
    inviteRecordListVisitor,
    newContactPersonList,
    simpleProductList,
    getExhibitorBrowseList,
    addCollection,
    getAppointmentPlace,
    getAppointmentList,
    browseListWithAI,
    getCollectionRankList
}